export default __webpack_public_path__ + "static/media/shivam.23205358.png";